import { render, staticRenderFns } from "./acta-intervencion-editar.vue?vue&type=template&id=4afc0c03&"
import script from "./acta-intervencion-editar.vue?vue&type=script&lang=js&"
export * from "./acta-intervencion-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports